import path from "path";

export const assetPrefix = (asset = "") => {
    const prefix = process.env.ASSET_PREFIX || "";

    return path.join(prefix, asset);
};
